import React, { useState, useEffect } from 'react';
import { Icon } from './icons';
import { AWS_CONFIG } from '../config/aws';
import { toYoutubeEmbed, youtubeThumb } from '../utils/youtube';

// Home intro video gallery. Admin sets one or more YouTube links (images category
// 'youtube'). Shows the selected video as the main player; other videos appear as
// thumbnails to switch. Only one iframe loads at a time (performance). Empty → placeholder.
export default function IntroVideo() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    fetch(`${AWS_CONFIG.apiUrl}/images?category=youtube`)
      .then(r => r.json())
      .then(data => {
        const list = (data.images || [])
          .map(v => ({ embed: toYoutubeEmbed(v.imageUrl), thumb: youtubeThumb(v.imageUrl), caption: v.alt || '' }))
          .filter(v => v.embed);
        setVideos(list);
      })
      .catch(() => {});
  }, []);

  const frame = {
    maxWidth: 800, margin: '0 auto', aspectRatio: '16 / 9', maxHeight: '50vh',
    background: 'var(--surface-elev)', border: '1px solid var(--border)',
    borderRadius: 'var(--radius)', overflow: 'hidden',
  };

  if (videos.length === 0) {
    return (
      <div style={{ ...frame, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'var(--text-dim)' }}>
        <span style={{ marginBottom: 12, color: 'var(--primary)', display: 'inline-flex' }}>
          <Icon name="PlayCircle" size={56} strokeWidth={1.2} />
        </span>
        <p style={{ fontSize: '1.1rem', marginBottom: 4 }}>영상 준비 중</p>
        <p style={{ fontSize: '0.85rem' }}>YouTube 영상이 이 자리에 표시됩니다</p>
      </div>
    );
  }

  const cur = videos[Math.min(active, videos.length - 1)];
  return (
    <div>
      <div style={frame}>
        <iframe
          src={cur.embed}
          title={cur.caption || 'KOA DETAILING 소개 영상'}
          style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
      {videos.length > 1 && (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginTop: 12, maxWidth: 800, marginLeft: 'auto', marginRight: 'auto' }}>
          {videos.map((v, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              title={v.caption}
              style={{
                width: 120, aspectRatio: '16 / 9', borderRadius: 8, overflow: 'hidden',
                cursor: 'pointer', padding: 0,
                border: i === active ? '2px solid var(--primary)' : '1px solid var(--border)',
                opacity: i === active ? 1 : 0.7,
              }}
            >
              <img src={v.thumb} alt={v.caption || `영상 ${i + 1}`} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
